import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralPostProcessorService } from './general-post-processor/general-post-processor.service';
import { PostProcessor } from './post-processor';
import { UpdateModelObjectPostProcessor } from './specific-post-processors/update-model-object-post-processor.service';
import { DeficiencyPostProcessor } from './specific-post-processors/deficiency-post-processor.service';
import { MoveToTourFormFieldPostProcessor } from './formfield-post-processor/move-to-tour-post-processor.service';
import { CargoItemsFormFieldPostProcessor } from './formfield-post-processor/cargoitem-post-processor.service';
import { PaymentFormFieldPostProcessor } from './formfield-post-processor/payment-post-processor.service';
import { JobGroupCargoItemsFormFieldPostProcessor } from './formfield-post-processor/job-group-cargoitem-post-processor.service';
import { CreateDeficiencyTicketListPostProcessor } from './formfield-post-processor/create-deficiency-ticket-list-post-processor.service';
import { CreateProjectContactDirectoryPostProcessor } from './formfield-post-processor/create-project-contact-directory-post-processor.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: PostProcessor,
      useExisting: UpdateModelObjectPostProcessor,
      multi: true,
    },
    {
      provide: PostProcessor,
      useExisting: DeficiencyPostProcessor,
      multi: true,
    },
    {
      provide: PostProcessor,
      useExisting: MoveToTourFormFieldPostProcessor,
      multi: true,
    },
    {
      provide: PostProcessor,
      useExisting: CargoItemsFormFieldPostProcessor,
      multi: true,
    },
    {
      provide: PostProcessor,
      useExisting: PaymentFormFieldPostProcessor,
      multi: true,
    },
    {
      provide: PostProcessor,
      useExisting: JobGroupCargoItemsFormFieldPostProcessor,
      multi: true,
    },
    {
      provide: PostProcessor,
      useExisting: CreateDeficiencyTicketListPostProcessor,
      multi: true,
    },
    {
      provide: PostProcessor,
      useExisting: CreateProjectContactDirectoryPostProcessor,
      multi: true,
    },
    GeneralPostProcessorService,
  ],
})
export class PostProcessorModule {}
